import React, { useEffect, useRef } from 'react';
import './ConversationDisplay.css'; 

function ConversationDisplay({ conversation }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [conversation]);

  return (
    <div className="conversation-display">
      {conversation
        // Filter out system messages
        .filter((msg) => msg.role !== "system")
        .map((msg, idx) => {
            const displayName = (msg.role === "assistant") ? "Jack Ass" : msg.role;
            return (
              <div key={idx} className="message-row">
                <strong>{displayName}:</strong> {msg.content}
              </div>
            );
        })}
      {/* Sentinel div for auto-scroll */}
      <div ref={bottomRef} />
    </div>
  );
}

export default ConversationDisplay;
